import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material"
import { DataNode } from "graphql/types"
import React from "react"

interface TableDiffPreviewProps {
  originalDataNode: DataNode
  currentDataNode: DataNode
}

export const TableDiffPreview: React.FC<TableDiffPreviewProps> = ({
  originalDataNode,
  currentDataNode,
}) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        Originale Tabelle {originalDataNode.tableNumber}
      </Typography>
      <Paper sx={{ overflow: "auto" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {originalDataNode.tableHeader.map((header: any, index: number) => (
                <TableCell key={index} sx={{ fontWeight: "bold" }} colSpan={header.colSpan || 1}>
                  {header.data || ""}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {originalDataNode.tableBody.map((row: any, rowIndex: number) => (
              <TableRow key={rowIndex}>
                {row.map((cell: any, cellIndex: number) => (
                  <TableCell key={cellIndex} colSpan={cell.colSpan || 1}>
                    {cell.data || ""}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  )
}
